module.exports = __webpack_public_path__ + "static/media/engineering_dropdown.764f5bb7.svg";